import axios from 'axios'

import {
  API_TIMEOUT,
  DL_APPS_COUNT
} from '../config'

export const client = axios.create({
  timeout: API_TIMEOUT
})

export default {
  getApps () {
    return client.get('/api/2.0.0/apps')
  },
  getDlApps () {
    return client.get(`/api/1.0.0/dl_apps?count=${DL_APPS_COUNT}`)
  }
}
